// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableTracing: true,
  loginType: '',
  PING_SSO_URL: '',
  ENTRA_SSO_URL: '',
  PING_LOGOUT_SSO: '',
  ENTRA_LOGOUT_SSO: '',
  ENTRA_LOGOUT_REDIRECT_SSO: '',
  USE_LEGACY_PING_SSO: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
